export const Contact = ({ showLink=true }) => (
  <span data-testid="contact-info">
    please contact BC Transplant at <span className="whitespace-nowrap">604-877-2240</span>, toll
    free at <span className="whitespace-nowrap">1-800-663-6189</span>, or{' '}
    <span className="whitespace-nowrap">e-mail</span> us at{' '}
    <a href="mailto:info@transplant.bc.ca">info@transplant.bc.ca</a>.
    { showLink &&
    <>If you would like to learn more about organ donation and transplant, visit our website at <a href="www.transplant.bc.ca">www.transplant.bc.ca</a>
    </>}
  </span>
)
